/**
 * @author twu
 * @description 配置表字段管理列表
 * @Date 2021/6/22
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool,component_tool,utils_tool } from '@/tool';
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport,WizCard,WizTabs,WizSpin} = component_tool;
let {Session} = utils_tool;
const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/dataReport/tableConfig/tableField') {
      if (history.location && history.location.record) {
        record = history.location.record;
        Session.set('tableConfigInfo', record)
      } else {
        record = Session.get('tableConfigInfo') || 0
      }
    }
  }
  return record
}
class TableFieldList extends WizContainer {

  componentName = 'tableFieldList';

  constructor(props) {
    super(props);
    this.state = {
    }
    this.initialValue = getParamRecord(props.history);
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _render() {
    let record = this.initialValue;
    let tableConfigId = null;
    if (record) {
      tableConfigId = record.id;
    }
    let _templateConfig = templateConfig({
      _this: this,
      tableConfigId,
    });
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig:_templateConfig,
      tableConfigId,
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        updateTableFieldState: this._handleCMD
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(TableFieldList);
